import type { DependencyList, EffectCallback } from 'react';

import isEqual from 'fast-deep-equal/react';

import { useCompareEffect } from './compare-effect.hook';

/**
 * A hook that runs an effect with deep comparison of dependencies.
 *
 * @param effect - The effect callback to run.
 * @param dependencies - An array of dependencies that, when changed, will cause the effect to re-run.
 *
 * @example
 * useDeepCompareEffect(() => {
 *   // Effect logic here
 * }, [dependency1, dependency2]);
 */
export const useDeepCompareEffect = (effect: EffectCallback, dependencies: DependencyList) => {
  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are memoized using useCompareEffect
  useCompareEffect(effect, dependencies, isEqual);
};
